var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('x-container',{attrs:{"title":"Discovery Tool","additionalChildren":_vm.subNavChildren,"showSidebar":false,"showSubContainer":!_vm.checkProjectRoute}})}
var staticRenderFns = []

export { render, staticRenderFns }